import React from "react";
// generics
import * as S from "../../styles";

export default function THeader({ headerLabels }: any) {
  return (
    <div className="header">
      {headerLabels.map((cell: any, i: number) => (
        <S.Cell header className={cell.key} key={i}>
          <p>
            {cell.label}
            {cell.label !== ""}
          </p>
        </S.Cell>
      ))}
    </div>
  );
}
